/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router";
import { useAuth } from "../../Utils/Auth";
import { toast } from "react-toastify";
import { toTitleCase } from "../../Utils/helper";
import Confirmation_dialog from "../confirmation_dialog";
const TopNavbar = ({ selectedMenuItem }) => {
    const confirmDialogInitialState = {
      show: false,
      title: "",
      message: "",
      confirmText: "",
      cancelText: "",
      isConfirm: false,
      isDenied: false,
      data : "",
      onSuccess : () => {}
    };
    const [showConfirmDialog, setShowConfirmDialog] = useState(
      confirmDialogInitialState
    );
  const nav = useNavigate();
  const auth = useAuth();

  const handleLogout = () => {
      auth.logout();
      toast.success("Logout successfully");
      nav("/");
  };
  const handelresetpass = () => {
    nav("/resetpassword");
  };

  let heading = "Dashboard";

  // Set heading based on selectedMenuItem
  if (selectedMenuItem === "dashboard") {
    heading = "Dashboard";
  } else if (selectedMenuItem === "Deposit") {
    heading = "Deposit";
  } else if (selectedMenuItem === "Withdraw") {
    heading = "Withdraw";
  } else if (selectedMenuItem === "Bank") {
    heading = "Bank Details";
  } else if (selectedMenuItem === "Website") {
    heading = "Website Details";
  } else if (selectedMenuItem === "createSubAdmin") {
    heading = "Create Sub-Admin";
  } else if (selectedMenuItem === "createUser") {
    heading = "Create User";
  } else if (selectedMenuItem === "createIntroducer") {
    heading = "Create Introducer";
  } else if (selectedMenuItem === "userProfile") {
    heading = "user Profile";
  } else if (selectedMenuItem === "introducerProfile") {
    heading = "Introducer Profile";
  } else if (selectedMenuItem === "subAdminProfile") {
    heading = "Sub-Admin Profile";
  } else if (selectedMenuItem === "AllTransactionDetails") {
    heading = "All Transaction Details";
  } else if (selectedMenuItem === "MyTransactions") {
    heading = "My Transactions";
  } else if (selectedMenuItem === "AllTransactionRequest") {
    heading = "All Transaction Requests";
  } else if (selectedMenuItem === "introducerTransactionRequest") {
    heading = " introducer Transactions Requests";
  } else if (selectedMenuItem === "BankEdit") {
    heading = "Bank Edit";
  } else if (selectedMenuItem === "BankDelete") {
    heading = "Bank Delete";
  } else if (selectedMenuItem === "NewBank") {
    heading = "New Bank Details";
  } else if (selectedMenuItem === "WebsiteEdit") {
    heading = "Website Edit";
  } else if (selectedMenuItem === "WebsiteDelete") {
    heading = "Website Delete";
  } else if (selectedMenuItem === "newWebsite") {
    heading = "New Website Details";
  } else if (selectedMenuItem === "AllTransactionTrash") {
    heading = "All Transaction Trash Details";
  }


    const handleConfirmDialogOpen = ( message, confirmText, cancelText , data , onConfirm) => {
      setShowConfirmDialog((state) => ({
        ...state,
        show: true,
        message: toTitleCase(message),
        confirmText: confirmText,
        cancelText: cancelText,
        data : data ,
        onSuccess : onConfirm
      }));
    };
    
  const handleConfirmDialogClose = () => {
    setShowConfirmDialog(confirmDialogInitialState);
  };

  return (
    <>
      <nav
        className="main-header navbar navbar-expand navbar-white navbar-light  "
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1001,
          backgroundColor: "#4682b4",
        }}
      >
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link"
              href="#"
              role="button"
              data-widget="pushmenu"
            >
              <i className="fas fa-bars"></i>
            </a>
          </li>

          <li className="nav-item d-none d-sm-inline-block">
            {/* <Link to="welcome" className="nav-link">
              Home
            </Link> */}
          </li>
        </ul>
        <div className="d-flex justify-content-center align-items-center flex-grow-1">
          <span
            className="navbar-brand"
            style={{ color: "white", fontWeight: "bold" }}
          >
            {selectedMenuItem}
          </span>
        </div>
        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <a
              className="nav-link"
              title="Reset Password"
              role="button"
              onClick={handelresetpass}
            >
              <i className="fas fa-edit"></i>
            </a>
          </li>
          <li className="nav-item">
            <a
              className="nav-link"
              title="Fullscreen"
              data-widget="fullscreen"
              href="#"
              role="button"
            >
              <i className="fas fa-expand-arrows-alt"></i>
            </a>
          </li>
          <li className="nav-item">
            <a
              className="nav-link"
              title="Log Out"
              data-widget="control-sidebar"
              data-controlsidebar-slide="true"
              href="#"
              role="button"
              onClick={() => {
                handleConfirmDialogOpen(
                  "are you sure you want to Logout ?",
                  "Yes",
                  "Cancel",
                  "",
                  handleLogout
                );
              }}
            >
              <i className="fas fa-sign-out-alt" style={{ color: "red" }}></i>
            </a>
          </li>
        </ul>
      </nav>
      <Confirmation_dialog
        show={showConfirmDialog.show}
        title={showConfirmDialog.title}
        message={showConfirmDialog.message}
        confirmText={showConfirmDialog.confirmText}
        cancelText={showConfirmDialog.cancelText}
        state={showConfirmDialog}
        onSuccess={showConfirmDialog.onSuccess}
        handleConfirmDialogClose={handleConfirmDialogClose}
      />
    </>
  );
};

export default TopNavbar;
